module.exports = __webpack_public_path__ + "img/ink.908abf6e.svg";